"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getListContainerHeight = exports.hasValueListOverflow = exports.getValueListWindowHeight = exports.getValueListHeight = exports.getValueListItemSize = exports.getDisplayValueEntriesKey = exports.getDisplayValueEntries = exports.getFilteredValueEntries = void 0;
const form_value_list_row_1 = require("../form-value-list-row");
const value_form_list_constants_1 = require("./value-form-list.constants");
const getFilteredValueEntries = (values, searchValue, matchedValueNames) => {
    const normalizedSearchValue = searchValue.trim().toLowerCase();
    const matchedValueNamesSet = matchedValueNames ? new Set(matchedValueNames.map((valueName) => valueName.toLowerCase())) : undefined;
    return values
        .map((value, index) => ({ type: 'value', value, index }))
        .filter(({ value }) => {
        var _a;
        if (!normalizedSearchValue) {
            return true;
        }
        const matchesLocally = value.name.toLowerCase().includes(normalizedSearchValue)
            || ((_a = value.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(normalizedSearchValue));
        if (!value.readonly) {
            return Boolean(matchesLocally);
        }
        if (!matchedValueNamesSet) {
            return Boolean(matchesLocally);
        }
        return matchedValueNamesSet.has(value.name.toLowerCase());
    });
};
exports.getFilteredValueEntries = getFilteredValueEntries;
const getDisplayValueEntries = (filteredValueEntries, canLoadMoreValues, sectionLabels) => {
    const newValueEntries = filteredValueEntries.filter(({ value }) => !value.readonly).reverse();
    const loadedValueEntries = filteredValueEntries.filter(({ value }) => value.readonly);
    const loadMoreEntry = canLoadMoreValues && filteredValueEntries.length ? [{ type: 'loadMore' }] : [];
    if (sectionLabels) {
        return [
            ...(newValueEntries.length ? [{ type: 'sectionLabel', label: sectionLabels.added }, ...newValueEntries] : []),
            ...(newValueEntries.length && loadedValueEntries.length ? [{ type: 'divider' }] : []),
            ...(loadedValueEntries.length ? [{ type: 'sectionLabel', label: sectionLabels.existing }, ...loadedValueEntries] : []),
            ...loadMoreEntry,
        ];
    }
    if (!newValueEntries.length || !loadedValueEntries.length) {
        return [...filteredValueEntries, ...loadMoreEntry];
    }
    return [
        ...newValueEntries,
        { type: 'divider' },
        ...loadedValueEntries,
        ...loadMoreEntry,
    ];
};
exports.getDisplayValueEntries = getDisplayValueEntries;
const getDisplayValueEntriesKey = (displayValueEntries) => displayValueEntries.map((entry) => {
    if (entry.type === 'divider') {
        return 'divider';
    }
    if (entry.type === 'sectionLabel') {
        return `sectionLabel:${entry.label}`;
    }
    if (entry.type === 'loadMore') {
        return 'loadMore';
    }
    return `${entry.index}:${entry.value.name}:${entry.value.readonly ? 'readonly' : 'editable'}`;
}).join('|');
exports.getDisplayValueEntriesKey = getDisplayValueEntriesKey;
const getValueListItemSize = (displayValueEntries, sizeMap, index) => {
    var _a, _b, _c;
    if (((_a = displayValueEntries[index]) === null || _a === void 0 ? void 0 : _a.type) === 'divider') {
        return form_value_list_row_1.LIST_DIVIDER_HEIGHT;
    }
    if (((_b = displayValueEntries[index]) === null || _b === void 0 ? void 0 : _b.type) === 'sectionLabel') {
        return form_value_list_row_1.LIST_SECTION_LABEL_HEIGHT;
    }
    if (((_c = displayValueEntries[index]) === null || _c === void 0 ? void 0 : _c.type) === 'loadMore') {
        return form_value_list_row_1.LIST_LOAD_MORE_HEIGHT;
    }
    return sizeMap[index] || form_value_list_row_1.LIST_ITEM_HEIGHT;
};
exports.getValueListItemSize = getValueListItemSize;
const getValueListHeight = (displayValueEntries, getSize) => {
    if (!displayValueEntries.length) {
        return 0;
    }
    return displayValueEntries.reduce((total, _value, index) => total + getSize(index), value_form_list_constants_1.LIST_TOP_OFFSET);
};
exports.getValueListHeight = getValueListHeight;
const getValueListWindowHeight = ({ shouldConstrainListHeight, listHeight, listContainerHeight, lastMeasuredListContainerHeight, }) => {
    if (!shouldConstrainListHeight) {
        return listHeight;
    }
    const measuredHeight = listContainerHeight || lastMeasuredListContainerHeight;
    if (!measuredHeight) {
        return Math.max(form_value_list_row_1.LIST_LOAD_MORE_HEIGHT, listHeight);
    }
    return Math.max(form_value_list_row_1.LIST_LOAD_MORE_HEIGHT, Math.min(listHeight, measuredHeight));
};
exports.getValueListWindowHeight = getValueListWindowHeight;
const hasValueListOverflow = (shouldConstrainListHeight, listHeight, listWindowHeight) => shouldConstrainListHeight && listHeight - listWindowHeight > value_form_list_constants_1.VALUE_LIST_OVERFLOW_TOLERANCE_PX;
exports.hasValueListOverflow = hasValueListOverflow;
const getListContainerHeight = (element) => {
    var _a;
    const elementRect = element.getBoundingClientRect();
    const parentRect = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    const availableHeight = parentRect
        ? Math.max(form_value_list_row_1.LIST_LOAD_MORE_HEIGHT, parentRect.bottom - elementRect.top)
        : elementRect.height;
    const elementHeight = elementRect.height > form_value_list_row_1.LIST_LOAD_MORE_HEIGHT ? elementRect.height : availableHeight;
    return Math.floor(Math.min(elementHeight, availableHeight));
};
exports.getListContainerHeight = getListContainerHeight;
